import { ApolloClient, InMemoryCache } from "@apollo/client";
import {
  EXECUTE_AURORA_SQL_QUERY,
  GET_QUERY_BUILDER_SCHEMA_QUERY,
  GET_AGENT_RESULTS_QUERY,
} from "../queries/auroraSqlQueries";

const AURORA_GRAPHQL_ENDPOINT =
  "https://gomiocbjmvdilowjdnezqh5jzq.appsync-api.us-east-1.amazonaws.com/graphql";

const auroraClient = new ApolloClient({
  uri: AURORA_GRAPHQL_ENDPOINT,
  cache: new InMemoryCache(),
  headers: {
    "x-api-key": "da2-na5luul3pfdqbfoqwymkmkfmvq",
  },
});

// Execute Dynamic Query (Aurora SQL)
export const executeAuroraSqlFromApi = async (query) => {
  try {
    console.log(
      `Aurora SQL API - executeAuroraSqlFromApi - query: ${JSON.stringify(
        query
      )}`
    );

    const apiPayload = {
      query: EXECUTE_AURORA_SQL_QUERY,
      variables: { query },
    };

    console.log(
      `Aurora SQL API - executeAuroraSqlFromApi - apiPayload: ${JSON.stringify(
        apiPayload
      )}`
    );

    const response = await auroraClient.query(apiPayload);

    console.log(
      `Aurora SQL API - executeAuroraSqlFromApi - response: ${JSON.stringify(
        response?.data?.executeDynamicQuery
      )}`
    );

    return response?.data?.executeDynamicQuery;
  } catch (error) {
    console.error(
      `Aurora SQL API - executeAuroraSqlFromApi - error: ${error.message}`
    );
    throw error;
  }
};

// Get Query Builder Schema
export const getQueryBuilderSchemaFromApi = async () => {
  try {
    console.log("Aurora SQL API - getQueryBuilderSchemaFromApi");

    const apiPayload = {
      query: GET_QUERY_BUILDER_SCHEMA_QUERY,
    };

    console.log(
      `Aurora SQL API - getQueryBuilderSchemaFromApi - apiPayload: ${JSON.stringify(
        apiPayload
      )}`
    );

    const response = await auroraClient.query(apiPayload);

    console.log(
      `Aurora SQL API - getQueryBuilderSchemaFromApi - response: ${JSON.stringify(
        response?.data?.getQueryBuilderSchema
      )}`
    );

    return response?.data?.getQueryBuilderSchema;
  } catch (error) {
    console.error(
      `Aurora SQL API - getQueryBuilderSchemaFromApi - error: ${error.message}`
    );
    throw error;
  }
};

// Get Agent Results (Alternative query)
export const getAgentResultsFromApi = async (query) => {
  try {
    console.log(
      `Aurora SQL API - getAgentResultsFromApi - query: ${JSON.stringify(
        query
      )}`
    );

    const apiPayload = {
      query: GET_AGENT_RESULTS_QUERY,
      variables: { query },
    };

    console.log(
      `Aurora SQL API - getAgentResultsFromApi - apiPayload: ${JSON.stringify(
        apiPayload
      )}`
    );

    const response = await auroraClient.query(apiPayload);

    console.log(
      `Aurora SQL API - getAgentResultsFromApi - response: ${JSON.stringify(
        response?.data?.getAgentResults
      )}`
    );

    return response?.data?.getAgentResults;
  } catch (error) {
    console.error(
      `Aurora SQL API - getAgentResultsFromApi - error: ${error.message}`
    );
    throw error;
  }
};
